import React from "react";
import Slider from "react-slick";
import TestimonialCard from "./TestimonialCard";

export default function SimpleSlider() {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay:true,
    loop:true
   
  };
  return (
    <div class="container-xxl pt-5">
    <div class="container">
        <div class="text-center text-md-start pb-5 pb-md-0 wow fadeInUp" data-wow-delay="0.1s"
            style={{maxWidth: "500px"}}>
            <p class="fs-5 fw-medium text-primary">Testimonial</p>
            <h1 class="display-5 mb-5">What Clients Say About Our Services!</h1>
        </div>
    <Slider {...settings}>
        <TestimonialCard name="Rahul Sharma" img="/img/testimonial-1.jpg" comment="Excellent service! My car looks brand new after their premium wash. The team is professional and uses eco-friendly products. Highly recommended for all car owners in Mumbai." profession="Business Owner"/>
         <TestimonialCard name="Priya Patel" img="/img/testimonial-2.jpg" comment="UrbanWash provides the best car washing service I've ever experienced. They pay attention to every detail and my car has never looked better. Great value for money!" profession="Software Engineer"/>
         <TestimonialCard name="Amit Kumar" img="/img/testimonial-3.jpg" comment="Outstanding service quality! The staff is courteous and the washing process is thorough. My vehicle always shines after their service. Definitely coming back!" profession="Marketing Manager"/>
         <TestimonialCard name="Sneha Reddy" img="/img/testimonial-4.jpg" comment="I've been using UrbanWash for over a year now and they never disappoint. Professional service, reasonable prices, and my car always looks spotless. Best car wash in the city!" profession="Teacher"/>
    </Slider>
    </div>
    </div>
  );
}